const { getVstopSSvetovanjemStrankaPrisotnaclen545Form } = require("./clen545.model");
const { getVstopSSvetovanjemStrankaPrisotnaZavarovalecForm } = require("./zavarovalec.model");

module.exports = { 
    getVstopSSvetovanjemStrankaPrisotnaForm: () => {
        return {
            zavarovalec: getVstopSSvetovanjemStrankaPrisotnaZavarovalecForm(),
            clen545: getVstopSSvetovanjemStrankaPrisotnaclen545Form(), 
        };
    },
};